import { Drawer, Image } from 'antd'
import { FiatType, useTokenStore } from 'state/useTokenStore'
import { useTranslation } from 'translations'

const SelectFiat = ({ onClose, open }) => {
	const { t } = useTranslation()
	const fiatList = useTokenStore((s) => s.fiatList)
	const setFiatTo = useTokenStore((s) => s.setFiatTo)

	const onSelect = (fiat: FiatType) => {
		setFiatTo(fiat)
		onClose()
	}

	return (
		<Drawer
			title={<p className='text-center font-bold text-xl'>{t("Send to")}</p>}
			placement="bottom"
			className='container !px-0'
			closable={false}
			onClose={onClose}
			height="60%"
			open={open}
			key="set-recipient"
		>
			<div className="flex flex-col gap-3">
				{
					!fiatList
						? <></>
						: fiatList.map(item => (
							<div className="border-solid border-[1px] rounded-lg border-[#ccc] flex items-center gap-2 p-3" key={item.symbol} onClick={() => onSelect(item)}>

								<div className="flex items-center gap-2 w-full" >
									<div className="flex-shrink-0">
										<Image preview={false} src={item.logo} className='!w-8 !h-8 rounded-full' />
									</div>

									<div className="flex flex-col gap-1">
										<p className="font-bold text-base">{item.name}</p>
										<p className="font-medium text-secondary">{item.currency_code}</p>
									</div>
								</div>
							</div>
						))
				}
			</div>
		</Drawer>
	)
}

export default SelectFiat